import { render, staticRenderFns } from "./IndexPage.vue?vue&type=template&id=26ae2160"
import script from "./IndexPage.vue?vue&type=script&lang=js"
export * from "./IndexPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports